import React from 'react';

import { OutputAudioHandlerContext, useOutputAudioHandler } from '../../../../../../hooks/use-output-audio-handler';
import { Island } from '../../../../island';
import { OutputDeviceSelect } from '../../sound-supported/output-device-select';
import css from '../styles.css';
import { OutputDeviceHeader } from './output-device-header';

export const OutputDeviceSection = () => {
    const audioHandler = useOutputAudioHandler();
    return (
        <Island className={css.soundWrapper}>
            <OutputAudioHandlerContext.Provider value={audioHandler}>
                <OutputDeviceHeader />
                <OutputDeviceSelect />
            </OutputAudioHandlerContext.Provider>
        </Island>
    );
};
